import WebServiceRequest from "@/libs/Api/WebServiceRequest";


class CreateScheduleStepDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleStepDiscount/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllScheduleStepDiscounts extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleStepDiscount/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAScheduleStepDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleStepDiscount/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleScheduleStepDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleStepDiscount/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateASingleScheduleStepDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleStepDiscount/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CreateScheduleStepDiscount,
  GetAllScheduleStepDiscounts,
  DeleteAScheduleStepDiscount,
  GetASingleScheduleStepDiscount,
  UpdateASingleScheduleStepDiscount,
};
